<template>
    <div class="fa">
        <!-- 单张图片的情况 -->
        <img v-if="!isArray" :src="getImgSrc(imgSrc)" :alt="alt" class="single-img"
            :class="{ 'img-small': size === 's' }">

        <!-- 多张图片的情况 -->
        <!-- 添加 vertical-mobile 类，当是数组时可用于移动端样式覆盖 -->
        <div v-else :class="['img-group', { 'vertical-mobile': isArray }]">
            <img v-for="(src, index) in imgSrc" :key="index" :src="getImgSrc(src)" :alt="alt"
                :style="{ width: `${100 / imgSrc.length}%` }" :class="{ 'img-small': size === 's' }" class="group-img">
        </div>
    </div>
</template>

<script>
export default {
    name: 'MyImg',
    props: {
        src: {
            type: [String, Array],
            required: true
        },
        size: {
            type: String,
            default: '',
            validator: function (value) {
                return ['', 's'].indexOf(value) !== -1
            }
        },
        alt: {
            type: String,
            require: true
        }
    },
    computed: {
        imgSrc() {
            return this.src;
        },
        isArray() {
            return Array.isArray(this.src);
        }
    },
    methods: {
        getImgSrc(name) {
            console.log(name);
            try {
                return require(`@/assets/${name}.webp`);
            } catch (e) {
                console.error(`找不到图片: ${name}.webp`);
                return '';
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.fa {
    display: flex;
    justify-content: center;
    margin: 35px 0;
    margin: auto;

    .single-img {
        height: auto;
        display: block;
        border-radius: 8px;

        &.img-small {
            margin: auto;
            width: 200px;
            height: 200px;
            object-fit: cover;
        }
    }

    .img-group {
        display: flex;
        gap: 15px;
        width: 100%;

        .group-img {
            height: auto;
            border-radius: 8px;
            object-fit: cover;

            &.img-small {
                width: 200px !important; // 覆盖内联样式
                height: 200px;
            }
        }
    }
}

// mobile
@media (max-width: 768px) {
    .fa {
        width: 100%;
    }

    .single-img {
        width: 70vw;
    }

    /* 当多图且为 vertical-mobile 时，移动端改为竖直排列并覆盖内联宽度 */
    .img-group.vertical-mobile {
        flex-direction: column;
        gap: 12px;
        align-items: center;
    }

    .img-group.vertical-mobile .group-img {
        width: 100% !important;
        /* 强制覆盖模板内联宽度，使图片竖向占满宽度 */
    }
}

// pc
@media (min-width: 768px) {
    .fa {
        margin: 0 auto;
        display: flex;
    }

    .single-img {
        width: 20vw;
    }

    .single-img,
    .group-img {
        transition: transform 0.3s ease;

        &:hover {
            transform: scale(1.02);
        }
    }
}
</style>